import { useState } from "react";
import { API_URL } from "../../../utils/common";

export interface AddUserAdminRequest {
    nombre: string;
    correo: string;
    idPerfil: number;
    estatus: number;
}

export interface AddUserAdminResponse {
    id: number;
    nombre: string;
    correo: string;
    idPerfil: number;
    estatus: number;
}

export const useAddUserAdmin = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [usuario, setUsuario] = useState<AddUserAdminResponse | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const agregarUsuario = async (
        payload: AddUserAdminRequest
    ): Promise<AddUserAdminResponse | null> => {

        setLoading(true);
        setError(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(`${API_URL}/cms/admin/usuarios`, {
                method: "POST",
                headers: {
                    Authorization: `bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error("Error al crear el usuario");
            }

            const data: AddUserAdminResponse = await response.json();

            setUsuario(data);

            return data;

        } catch (err: any) {

            console.error(err);
            setError(err.message || "Ocurrió un error");

            return null;

        } finally {

            setLoading(false);

        }
    };

    return {
        usuario,
        loading,
        error,
        agregarUsuario,
    };
};